import type { ChangeEvent, Dispatch, SetStateAction } from 'react'
import type { results } from '@/content/sections/header/subcomponents/search/subcomponents/results'
import type { searchResponse } from '@/content/sections/header/subcomponents/search/subcomponents/searchResponse'
import { api } from '@/content/services/api'
import { cmsDataService } from '@/content/services/cms.data.service'

export async function getSearchRes(value: string, minSearchLength: number): Promise<searchResponse> {
    const emptyResponse = (): searchResponse => ({
        results: [],
        showEmptyState: false,
    })

    if (value.length < minSearchLength) return emptyResponse()

    const { culture } = cmsDataService.get()
    const results = await api.GET<results[]>(api.Search(value, culture))

    return {
        results: results || [],
        showEmptyState: false,
    }
}

export async function setSearchResAsync(
    e: ChangeEvent<HTMLInputElement>,
    setSearchRes: (value: ((prevState: searchResponse) => searchResponse) | searchResponse) => void,
    setLoading: Dispatch<SetStateAction<boolean>>
) {
    setLoading(true)
    try {
        const _searchRes = await getSearchRes(e.target.value, 3)
        setSearchRes(_searchRes)
    } finally {
        setLoading(false)
    }
}
